import React from "react";
import { SearchOutlined } from '@ant-design/icons';
import { Input, Button, Divider } from "antd";

export const CustomFilterInput = ({
    setSelectedKeys,
    selectedKeys,
    confirm,
    clearFilters,
}) => {

    const handleSearch = () => {
        confirm({ closeDropdown: false }); // aplica filtro sin cerrar el dropdown
    };

    const handleReset = () => {
        clearFilters();
        confirm(); // aplica la limpieza y cierra el dropdown
    };

    const handleChange = (e) => {
        const value = e.target.value;
        setSelectedKeys(value ? [value] : []);
    };

    const hasValue = !!selectedKeys[0];

    return (
        <div
            style={{
                padding: 8,
                paddingBottom: 8,
                position: "relative",
            }}
        >
            <Input
                placeholder="Buscar"
                value={selectedKeys[0]}
                onChange={handleChange}
                onPressEnter={handleSearch}
                prefix={<SearchOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                style={{
                    marginBottom: 8,
                    width: "100%",
                    whiteSpace: "nowrap",
                }}
            />

            <Divider style={{ margin: "8px 0" }} />

            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                }}
            >
                <Button
                    size="small"
                    type="link"
                    disabled={!hasValue}
                    onClick={handleReset}
                >
                    Reiniciar
                </Button>

                <Button type="primary" size="small" onClick={handleSearch}>
                    Aceptar
                </Button>
            </div>
        </div>
    );
};
